import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { DeleteRounded } from '@mui/icons-material';
import { Typography } from '../../atoms/Typography';
import { COLORS } from '../../../configs/colors';

export const NameWrapper = styled(Stack)`
  width: 350px;
`;

export const StyledTypography = styled(Typography)`
  display: inline-block;
  white-space: pre-line;
  color: ${COLORS.Gray};
`;

export const ChildLocationDelete = styled(DeleteRounded)`
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
`;